import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import {get} from 'lodash';

import { Vehicle } from '@commons/models/domain/Vehicle';

@Component({
  selector: 'app-vehicle-text-value-control',
  templateUrl: './vehicle-text-value-control.component.html',
  changeDetection: ChangeDetectionStrategy.Default
})
export class VehicleTextValueControlComponent {

  @Input('data') set data(value: Vehicle) {
    setTimeout(() => {
      this.calculate(value);
    }, 0);
  }
  @Input() public group: number;
  @Input() public paramPathToDisplay: string;
  @Input() public unit: string
  @Input() public isParamValue: boolean;
  @Input() public isCopyActive: boolean;

  public value: any;

  constructor() { }

  private calculate(data: Vehicle): void {
    if (this.isParamValue) {
      this.value = get(data, this.paramPathToDisplay, '-');
      return;
    }

    let control = (data.ControlIndicators || []).filter(o => o && o.Group === this.group);
    let value = (control && control.length > 0 && control[0].LV) ? control[0].LV : null;
    if (value) {
      this.value = get(value, this.paramPathToDisplay, '-');
    }
  }

  public copyValue(value?: string): void {
    value && navigator.clipboard.writeText(value);
  }

}
